<template>
	<div class="need_login_popup_wrap">
		<div v-if="isWechat" class="need_wechat_login_popup">
			<div class="auth_tip">需要绑定映目账号用于答题完毕后的优惠活动</div>
			<div class="need_login_btn" @click="toBind">去绑定</div>
		</div>
		<div v-else class="need_login_popup">
			<div class="auth_tip">需要获取您的用户信息用于答题完毕后的优惠活动</div>
			<div v-if="!isLogin" class="need_login_btn" @click="toLogin">去登录</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ssoUrlLogin } from '@/services/indexnew';
import { isWechat } from 'ourwill-feutil/common/ua';
import doformSubmit from 'ourwill-feutil/broswer/formSubmit';
import config from '@/config';
export default {
	name: 'NeedLoginPopup',
	data() {
		return {
			isWechat: false,
		};
	},
	computed: {
		...mapState({
			userInfo: (state) => state.user.userInfo,
		}),
		isLogin() {
			return Boolean(this.userInfo && this.userInfo.id);
		},
	},
	mounted() {
		this.isWechat = isWechat(navigator.userAgent);
	},
	methods: {
		...mapActions({
			getUserInfo: 'user/getUserInfo',
		}),
		toLogin() {
			const loginUrl = ssoUrlLogin + encodeURIComponent(location.href) + '&channel=119';
			location.href = loginUrl;
		},
		toBind() {
			const data = {
				unionId: this.userInfo.unionid,
				nickname: this.userInfo.nickname,
				avatar: this.userInfo.avatar,
			};
			this.formSubmit(data, 119);
		},
		formSubmit(data, registerCode) {
			if (!this.isWechat) {
				return;
			}
			const url = config.bindLink + encodeURIComponent(location.href) + `&channel=${registerCode}`;
			doformSubmit(data, url);
		},
	},
};
</script>

<style lang="less">
.need_login_popup_wrap {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.6);
	z-index: 999999;
	.need_wechat_login_popup {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		background-color: rgba(255, 255, 255, 1);
		padding: 16px 32px;
		box-sizing: border-box;
		border-radius: 16px 16px 0 0;
	}
	.need_login_popup {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 420px;
		background-color: rgba(255, 255, 255, 1);
		padding: 32px;
		box-sizing: border-box;
		border-radius: 16px;
	}
	.auth_tip {
		width: 100%;
		text-align: center;
		font-size: 14px;
		color: #4f4e4e;
		font-weight: 500;
		line-height: 30px;
	}
	.need_login_btn {
		margin-top: 20px;
		width: 100%;
		height: 34px;
		line-height: 34px;
		border-radius: 20px;
		background-color: #18ac19;
		color: #ffffff;
		font-size: 16px;
		text-align: center;
		cursor: pointer;
	}
}
</style>
